import React from "react";
import { convertThenFormat, formatDateTimezon } from "../common-data/Converts";

const CuponListMobile = ({ tableData, setModValues }) => {
  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name name-checkbox">
                    {row?.type || "NA"}
                  </h3>

                  <span
                    className={`lead-type`}
                    style={{
                      background: "#E2EFD5",
                      color: "#379C00",
                    }}
                  >
                    {row?.coupon || "NA"}
                  </span>
                </div>

                <div
                  className="card-other-info"
                  style={{ padding: "0 20px 20px 20px" }}
                >
                  <span className="value semi-bold">
                    plan price:{" "}
                    <b>₹{convertThenFormat(row?.plan_price || 0)}</b>
                  </span>

                  <span className="value email semi-bold">
                    date added:{" "}
                    <b>
                      {row?.date_added
                        ? formatDateTimezon(row.date_added)
                        : "-"}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    status: <b>{row?.status || "NA"}</b>
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <div className="all-btns lead-btn-axceed">
                    <div className="lead-log-box">
                      <button
                        className="lead-log view-lead"
                        onClick={() => {
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpenExtendDays: true,
                            rowDataExtendDays: row,
                          }));
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-view-list"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
                        </svg>
                      </button>

                      <span className="btn-label">Apply Offer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default CuponListMobile;
